import React, { FC, Fragment, useEffect } from "react";
import styled from "styled-components";
import useOdataScheme, { useGridSettingsKey } from "./hook";
import { GridContainer } from "../../GridContainer/GridContainer";
import { EmptyContainer } from "../../Widgets/common";
import GenericScheme, { SchemeSection } from "../GenericScheme";
import { SchemeSkeleton } from "../SchemeSkeleton";

interface ODataSchemeProps {
  schemePath: string;
  restorePropPanel?: boolean;
  isMainView?: boolean;
}

const ODataScheme: FC<ODataSchemeProps> = ({ schemePath, restorePropPanel, isMainView }) => {
  const { isLoading, propertyAnnotations, scheme } = useOdataScheme(schemePath);
  const gridSettingsKey = useGridSettingsKey(scheme?.detailsList?.id);
  // const { pathname } = useLocation();
  // const log = useComponentLogger(ODataScheme);
  // const { showPropertiesPanel } = useSchemes();

  useEffect(() => {
    if (!restorePropPanel || isLoading || !scheme?.detailsList?.id) {
      return;
    }

    // const objectPath = LastViewStateStorage.getLastOpenedObject(pathname);
    // if (objectPath) {
    //   log.debug("Unsaved props detected", objectPath);
    //   showPropertiesPanel({ id: objectPath, parentId: scheme?.detailsList?.id });
    // }
  }, [isLoading]);

  if (isLoading) {
    return <SchemeSkeleton />;
  }

  if (!scheme?.detailsList) {
    if (scheme?.items?.length) {
      if (scheme.items[0].type === "html-page") {
        scheme.layout = []; // TODO: remove after updating ui.schema package
        return <GenericScheme {...scheme} />;
      }

      if (scheme.type === "scheme-section") {
        return <SchemeSection {...scheme} childrenGap={8} />;
      }
      return (
        <ShortenedEmptyContainer>
          <GenericScheme {...scheme} childrenGap={8} />
        </ShortenedEmptyContainer>
      );
    }
    return <Fragment />;
  }

  const Wrapper = isMainView ? GridWrapper : React.Fragment;

  return (
    <Wrapper>
      <GridContainer
        scheme={scheme!}
        propertyAnnotations={propertyAnnotations}
        gridSettingsKey={gridSettingsKey}
        isMainView={!!isMainView}
      />
    </Wrapper>
  );
};

const GridWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  ${(props) => props.theme.elementStyles.gridWrapper}
`;

const ShortenedEmptyContainer = styled(EmptyContainer)`
  font-size: 14px;
  max-width: 80%;
  text-align: center;
`;

export default ODataScheme;
